import { useSelector } from "react-redux";

export const useCompanyInformationSelector = () => {
  return useSelector((state) => state.companyInformation)
}